<template>
  <div :class="`${name}`" @click="clickHandler">
    <div :class="`${name}-left`">
      <div :class="`${name}-left_up`">
        {{ title }}
      </div>
      <div :class="`${name}-left_down`">
        {{ placeholder }}
      </div>
    </div>
    <div :class="`${name}-right`">
      <byted-icon-down style="line-height:0;margin-left:2px;" theme="outline" size="20" fill="#6D6E70" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue-demi';
import BytedIconDown from '@byte-design/vue-icons/icons/Down';

const name = 'audience-block';
export default defineComponent({
  name,
  components: {
    BytedIconDown
  },
  props: {
    title: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  setup(_, { emit }) {
    const clickHandler = () => {
      emit('actions');
    };
    return {
      name,
      clickHandler
    };
  }
});
</script>
<style lang="scss">
.audience-block {
  display: flex;
  height: 60px;
  width: 100%;
  padding: 0 16px;
  margin: auto;
  &-left {
    height: 50px;
    position: relative;
    width: 98%;
    &_up {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: var(--ks-sys-color-neutral-highOnSurface);
    }
    &_down {
      font-weight: 400;
      font-size: 12px;
      line-height: 24px;
      color: var(--ks-sys-color-neutral-onSurface);
    }
  }
  &-right {
    height: 60px;
    position: relative;
    top: 50%;
    &_icon {
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    };
  }
}
@import '~@/style/color.scss';
</style>
